
/**
 * Componente de controle de permissões.
 *
 * @param {Array} permissions - Lista de permissões do usuário (ex: ['criar', 'editar', 'apagar']).
 * @param {string} permission - Permissão requerida para exibir o conteúdo.
 * @param {ReactNode} children - Conteúdo a ser renderizado se a permissão for válida.
 */
const VerifyPermission = ({ permissions = [], permission, children, verificacaoSimples }) => {
    const isAuthorized = permissions.includes(permission) || permissions.includes(verificacaoSimples ? permission : 'allPermissions');

    return isAuthorized ? <>{children}</> : null;
};

export default VerifyPermission;
